import {
  demandeEvaluatingAdd,
  userInfoEvaluating,
  designScheme,
  getRadCustomerInfo,
  getWxUserInfo,
  evaluatingInfo,
  userFlockInfo,
  userEvaluatingReport,
  getServiceUserList,
  saveServiceUser
} from '@/api/rad'

const state = {
}

const mutations = {
}

const actions = {
  // 新建需求评测
  demandeEvaluatingAdd({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      demandeEvaluatingAdd(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户测评信息
  userInfoEvaluating({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      userInfoEvaluating(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户测评报告
  userEvaluatingReport({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      userEvaluatingReport(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户测评报告
  getRadCustomerInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getRadCustomerInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 设计方案
  designScheme({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      designScheme(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户需求评测信息
  evaluatingInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      evaluatingInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户群信息
  userFlockInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      userFlockInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户群信息
  getWxUserInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getWxUserInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // v-1.2.0-08-保存客户服务人员
  saveServiceUser({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveServiceUser(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // v-1.2.0-09-获取客户服务人员
  getServiceUserList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getServiceUserList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
